import { CHECKLIST_ITEM_TYPE } from 'src/constants/tasksV2';

export default {
    id: 1,
    type: CHECKLIST_ITEM_TYPE.CONFIRMATION,
    manifestKey: 'CONFIRMATION',

    try_it: {
        button_label: 'Toggle Confirmation',
        cell_component_import: {
            from: 'src/pages/dashboard/tables/AllLeadTable/TaskChecklistField',
            named: 'ConfirmationCell',
        },
        prefill: { completion_state: 'YES', response_payload: {} },
    },
    pre_flight_diff: [
        'Checklist item: PENDING → YES',
        'TaskActivity row created with action CHECKLIST_ITEM_COMPLETED',
        'Task auto-advances PENDING → IN_PROGRESS on first YES',
        'Task auto-completes if all required items done (auto_complete_on_checklist=true)',
        'No lead-side effect',
    ],
    has_step2_throttle: false,
    validation_laboratory: null,
};
